import { render, staticRenderFns } from "./general-ledger.vue?vue&type=template&id=7adcf974&scoped=true&"
import script from "./general-ledger.vue?vue&type=script&lang=js&"
export * from "./general-ledger.vue?vue&type=script&lang=js&"
import style0 from "./general-ledger.vue?vue&type=style&index=0&id=7adcf974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adcf974",
  null
  
)

export default component.exports